import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.company.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-company-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.company.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCompanyListComponent implements OnInit {
    @Input() view: any;
    @Input() category: any = 'investment';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.view == "admin") await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        else await this.service.auth.allow(true, "/landing");
        await this.load();
    }

    public loading: boolean = false;
    public list: any = [];
    public search: any = {
        text: "",
        page: 1,
        dump: 50
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public categoryConfig: any = {
        received: { label: '접수기업', path: 'received_company' },
        investment: { label: '투자기업', path: 'company' },
        review: { label: '검토기업', path: 'review_company' },
        meeting: { label: '미팅기업', path: 'meeting_company' },
        exit: { label: '회수기업', path: 'exit_company' },
        dropped: { label: '드랍기업', path: 'dropped_company' }
    };

    public sortField: string = '';
    public sortOrder: string = 'ASC';
    public selectedCompanyIds: any = {};
    public quarterReportLoading: boolean = false;
    public quarterReportModalOpen: boolean = false;
    public quarterReportRows: any[] = [];
    public companyRequestModalOpen: boolean = false;
    public companyRequestSaving: boolean = false;
    public companyRequestHistoryOpen: boolean = false;
    public companyRequestHistoryLoading: boolean = false;
    public companyRequestDetailOpen: boolean = false;
    public companyRequestDetailLoading: boolean = false;
    public companyRequests: any[] = [];
    public selectedCompanyRequestBatch: any = null;
    public companyRequestForm: any = {};
    public requestTypeOptions: any[] = [
        { key: 'quarter_report', label: '분기보고 요청' },
        { key: 'general', label: '별도 요청' }
    ];

    public gradeOrder: any = { 'S': 1, 'A': 2, 'B': 3, 'C': 4, 'D': 5, '': 6 };
    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-700 border border-blue-300',
        'A': 'bg-emerald-100 text-emerald-700 border border-emerald-300',
        'B': 'bg-yellow-100 text-yellow-700 border border-yellow-300',
        'C': 'bg-orange-100 text-orange-700 border border-orange-300',
        'D': 'bg-red-100 text-red-700 border border-red-300',
    };

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            const numericFields = ['investment_amount'];
            this.sortOrder = numericFields.includes(field) ? 'DESC' : 'ASC';
        }
        const dir = this.sortOrder === 'ASC' ? 1 : -1;
        this.list.sort((a, b) => {
            let va: any, vb: any;
            if (field === 'company_name') {
                va = a.company_name || ''; vb = b.company_name || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'description') {
                va = a.description || ''; vb = b.description || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'location') {
                va = a.extra?.location_short || ''; vb = b.extra?.location_short || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'fund_name') {
                va = (a.investment && a.investment[0]?.fund_name) || '';
                vb = (b.investment && b.investment[0]?.fund_name) || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'ceo') {
                va = a.ceo || ''; vb = b.ceo || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'ceo_phone') {
                va = a.ceo_phone || ''; vb = b.ceo_phone || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'manager') {
                va = a.manager || ''; vb = b.manager || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'manager_phone') {
                va = a.manager_phone || ''; vb = b.manager_phone || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'latest_grade') {
                va = this.gradeOrder[a.latest_grade] || 6;
                vb = this.gradeOrder[b.latest_grade] || 6;
                return (va - vb) * dir;
            }
            return 0;
        });
        await this.service.render();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.search.status = this.category;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public categoryLabel(): string {
        return this.categoryConfig[this.category]?.label || '투자기업';
    }

    public iterItems(item: any) {
        if (item.investment.length == 0) {
            let row: any = JSON.parse(JSON.stringify(item));
            row.investment = {};
            row._rowspan = 1;
            return [row];
        }

        let rows: any = [];
        for (let i = 0; i < item.investment.length; i++) {
            let row: any = JSON.parse(JSON.stringify(item));
            if (i == 0) row._rowspan = item.investment.length;
            row.investment = item.investment[i];
            rows.push(row);
        }

        return rows;
    }

    public isQuarterReportEnabled(): boolean {
        return this.category === 'investment';
    }

    public pageCompanyIds(): string[] {
        return (this.list || []).map((item: any) => item.id).filter((id: string) => !!id);
    }

    public selectedIds(): string[] {
        return Object.keys(this.selectedCompanyIds).filter((id: string) => this.selectedCompanyIds[id]);
    }

    public selectedCount(): number {
        return this.selectedIds().length;
    }

    public isSelected(id: string): boolean {
        return !!this.selectedCompanyIds[id];
    }

    public allPageSelected(): boolean {
        const ids = this.pageCompanyIds();
        return ids.length > 0 && ids.every((id: string) => this.isSelected(id));
    }

    public async toggleCompanySelection(id: string, event: any) {
        const checked = !!event?.target?.checked;
        this.selectedCompanyIds[id] = checked;
        await this.service.render();
    }

    public async togglePageSelection(event: any) {
        const checked = !!event?.target?.checked;
        for (const id of this.pageCompanyIds()) {
            this.selectedCompanyIds[id] = checked;
        }
        await this.service.render();
    }

    public dataStatusLabel(item: any): string {
        if (item?.is_new) return '입력됨';
        return '미입력';
    }

    public dataStatusClass(item: any): string {
        if (item?.is_new) return 'bg-emerald-50 text-emerald-700';
        return 'bg-red-50 text-red-600';
    }

    public async requestQuarterReport() {
        await this.openCompanyRequestModal('quarter_report');
    }

    public currentYear(): number {
        return new Date().getFullYear();
    }

    public currentQuarter(): number {
        return Math.floor(new Date().getMonth() / 3) + 1;
    }

    public resetCompanyRequestForm(requestType: string = 'quarter_report') {
        const year = this.currentYear();
        const quarter = this.currentQuarter();
        this.companyRequestForm = {
            request_type: requestType,
            company_data_required: requestType === 'quarter_report',
            year,
            quarter,
            title: requestType === 'quarter_report' ? `${year}년 ${quarter}분기 분기보고 요청` : '자료 요청',
            message: '',
            questions: [],
            attachments: []
        };
    }

    public async syncCompanyRequestType() {
        const type = this.companyRequestForm.request_type;
        const year = this.companyRequestForm.year || this.currentYear();
        const quarter = this.companyRequestForm.quarter || this.currentQuarter();
        if (type === 'quarter_report') {
            this.companyRequestForm.title = `${year}년 ${quarter}분기 분기보고 요청`;
            this.companyRequestForm.company_data_required = true;
        } else {
            if (!this.companyRequestForm.title || this.companyRequestForm.title.indexOf('분기보고 요청') >= 0) {
                this.companyRequestForm.title = '자료 요청';
            }
            this.companyRequestForm.company_data_required = false;
        }
        await this.service.render();
    }

    public async toggleCompanyDataRequest(event: any) {
        this.companyRequestForm.company_data_required = !!event?.target?.checked;
        await this.service.render();
    }

    public async addRequestQuestion() {
        if (!Array.isArray(this.companyRequestForm.questions)) this.companyRequestForm.questions = [];
        this.companyRequestForm.questions.push({ question: '' });
        await this.service.render();
    }

    public async removeRequestQuestion(index: number) {
        if (!Array.isArray(this.companyRequestForm.questions)) return;
        this.companyRequestForm.questions.splice(index, 1);
        await this.service.render();
    }

    public async openCompanyRequestModal(requestType: string = 'quarter_report') {
        const ids = this.selectedIds();
        if (ids.length === 0) {
            await this.service.alert.error('요청할 기업을 선택해 주세요.');
            return;
        }
        this.resetCompanyRequestForm(requestType);
        this.companyRequestModalOpen = true;
        await this.service.render();
    }

    public async closeCompanyRequestModal() {
        this.companyRequestModalOpen = false;
        await this.service.render();
    }

    public async addRequestAttachment() {
        if (!Array.isArray(this.companyRequestForm.attachments)) this.companyRequestForm.attachments = [];
        this.companyRequestForm.attachments.push({
            title: '',
            name: '',
            url: '',
            upload_status: 'pending'
        });
        await this.service.render();
    }

    public async uploadRequestAttachment() {
        await this.addRequestAttachment();
    }

    public async uploadRequestAttachmentFile(index: number) {
        if (!Array.isArray(this.companyRequestForm.attachments)) return;
        const attachment = this.companyRequestForm.attachments[index];
        if (!attachment) return;

        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const file = files[0];

        await this.service.loading.show();
        try {
            attachment.name = file.name;
            attachment.url = '';
            attachment.upload_status = 'uploading';
            await this.service.render();

            const fd = new FormData();
            fd.append('upload', file);
            try {
                const { url } = await this.service.file.upload('/file/upload?mode=company_request', fd, async () => { });
                attachment.url = url;
                attachment.upload_status = 'uploaded';
            } catch (e) {
                attachment.upload_status = 'failed';
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async removeRequestAttachment(index: number) {
        if (!Array.isArray(this.companyRequestForm.attachments)) return;
        this.companyRequestForm.attachments.splice(index, 1);
        await this.service.render();
    }

    public async submitCompanyRequest() {
        const ids = this.selectedIds();
        if (ids.length === 0) {
            await this.service.alert.error('요청할 기업을 선택해 주세요.');
            return;
        }
        if (!this.companyRequestForm.title) {
            await this.service.alert.error('요청 제목을 입력해 주세요.');
            return;
        }
        const missingAttachmentTitles = (this.companyRequestForm.attachments || []).filter((item: any) => !String(item?.title || '').trim());
        if (missingAttachmentTitles.length > 0) {
            await this.service.alert.error('첨부파일 제목을 입력해 주세요.');
            return;
        }
        const incompleteAttachments = (this.companyRequestForm.attachments || []).filter((item: any) => item.upload_status !== 'uploaded' || !item.url);
        if (incompleteAttachments.length > 0) {
            await this.service.alert.error('업로드가 완료되지 않은 첨부파일이 있습니다.');
            return;
        }

        this.companyRequestSaving = true;
        this.quarterReportLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_company_request', {
            company_ids: JSON.stringify(ids),
            request_type: this.companyRequestForm.request_type,
            title: this.companyRequestForm.title,
            message: this.companyRequestForm.message || '',
            year: this.companyRequestForm.year || '',
            quarter: this.companyRequestForm.quarter || '',
            company_data_required: this.companyRequestForm.company_data_required ? 'true' : 'false',
            questions: JSON.stringify(this.companyRequestForm.questions || []),
            attachments: JSON.stringify(this.companyRequestForm.attachments || [])
        });
        this.companyRequestSaving = false;
        this.quarterReportLoading = false;

        if (code !== 200) {
            await this.service.alert.error(data?.message || '요청 등록에 실패했습니다.');
            await this.service.render();
            return;
        }

        this.companyRequestModalOpen = false;
        this.companyRequests = data.rows || [];
        if (this.companyRequestForm.company_data_required) {
            this.quarterReportRows = data.quarter_rows || [];
            this.quarterReportModalOpen = true;
        } else {
            await this.service.alert.success('요청을 등록했습니다.');
        }
        await this.loadCompanyRequests(false);
        await this.service.render();
    }

    public async closeQuarterReportModal() {
        this.quarterReportModalOpen = false;
        await this.service.render();
    }

    public async loadCompanyRequests(showLoading: boolean = true) {
        if (showLoading) {
            this.companyRequestHistoryLoading = true;
            await this.service.render();
        }
        const { code, data } = await wiz.call('company_requests', {
            dump: 500,
            detail: 'false'
        });
        this.companyRequestHistoryLoading = false;
        if (code === 200) {
            this.companyRequests = data.rows || [];
        }
        await this.service.render();
    }

    public async openCompanyRequestHistory() {
        this.companyRequestHistoryOpen = true;
        await this.loadCompanyRequests(true);
    }

    public async closeCompanyRequestHistory() {
        this.companyRequestHistoryOpen = false;
        await this.service.render();
    }

    public companyRequestHistoryTitle(): string {
        return '요청 내역';
    }

    public requestCompanyNames(batch: any): string {
        const names = (batch?.company_preview || batch?.companies || []).map((item: any) => {
            if (typeof item === 'string') return item;
            return item?.name;
        }).filter((name: string) => !!name);
        const total = batch?.company_count || names.length;
        if (total > names.length && names.length > 0) return `${names.slice(0, 3).join(', ')} 외 ${total - names.length}개`;
        if (names.length <= 3) return names.join(', ');
        return `${names.slice(0, 3).join(', ')} 외 ${Math.max(total - 3, 0)}개`;
    }

    public requestPreview(batch: any): string {
        const text = (batch?.message || '').replace(/\s+/g, ' ').trim();
        if (text) return text;
        const attachments = batch?.attachments || [];
        if (attachments.length > 0) return `첨부파일 ${attachments.length}개`;
        return '요청 내용 없음';
    }

    public attachmentCount(batch: any): number {
        return (batch?.attachments || []).length;
    }

    public isQuarterBatch(batch: any): boolean {
        return batch?.request_type === 'quarter_report';
    }

    public showCompanyDataStatus(batch: any): boolean {
        return this.isQuarterBatch(batch) || !!batch?.company_data_required;
    }

    public requestBatchStatusText(batch: any): string {
        if (!batch?.detail_loaded) return `대상 ${batch?.company_count || 0}개 기업`;
        if (!this.showCompanyDataStatus(batch)) return `대상 ${batch?.company_count || 0}개 기업`;
        return `요청 ${batch?.company_count || 0}개 · 제출 ${batch?.submitted_company_count || 0}개`;
    }

    public async openCompanyRequestDetail(batch: any) {
        this.selectedCompanyRequestBatch = batch;
        this.companyRequestDetailOpen = true;
        this.companyRequestDetailLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('company_requests', {
            dump: 10000,
            batch_id: batch?.id || '',
            detail: 'true'
        });
        this.companyRequestDetailLoading = false;
        if (code === 200 && data?.rows?.length > 0) {
            this.selectedCompanyRequestBatch = data.rows[0];
        } else {
            await this.service.alert.error('요청 상세를 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async closeCompanyRequestDetail() {
        this.companyRequestDetailOpen = false;
        this.selectedCompanyRequestBatch = null;
        this.companyRequestDetailLoading = false;
        await this.service.render();
    }

    public selectedCompanyRequestCompanies(): any[] {
        return this.selectedCompanyRequestBatch?.companies || [];
    }

    public companyRequestCompanyLink(company: any): string {
        if (!company?.id) return '';
        return this.baseLink('/' + company.id + '/overview');
    }

    public emailBadgeClass(status: string = ''): string {
        if (status === 'sent') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-amber-50 text-amber-700';
        if (status === 'failed') return 'bg-red-50 text-red-600';
        if (status === 'no_recipient') return 'bg-zinc-100 text-zinc-600';
        return 'bg-zinc-100 text-zinc-500';
    }

    public companyEmailText(company: any): string {
        if (company?.email_status_label) return company.email_status_label;
        return '-';
    }

    public submissionBadgeClass(status: string = ''): string {
        if (status === 'complete') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-amber-50 text-amber-700';
        return 'bg-red-50 text-red-600';
    }

    public companySubmissionText(company: any): string {
        return company?.submission_status_label || '미제출';
    }

    public companyDocuments(company: any): any[] {
        return company?.data || [];
    }

    public attachmentTitle(file: any): string {
        return file?.title || file?.name || '첨부파일';
    }

    public attachmentStatusText(file: any): string {
        if (file?.upload_status === 'uploaded') return '업로드 완료';
        if (file?.upload_status === 'uploading') return '업로드 중';
        if (file?.upload_status === 'failed') return '업로드 실패';
        return '파일 미선택';
    }

    public attachmentStatusClass(file: any): string {
        if (file?.upload_status === 'uploaded') return 'bg-emerald-50 text-emerald-700';
        if (file?.upload_status === 'failed') return 'bg-red-50 text-red-600';
        return 'bg-amber-50 text-amber-700';
    }

    public dataAttachments(item: any): any[] {
        return item?.attachments || [];
    }

    public submittedAttachments(company: any): any[] {
        return company?.submitted_attachments || [];
    }

    public companySubmittedItems(company: any): string {
        const labels = company?.submitted_item_labels || [];
        if (labels.length === 0) return '-';
        if (labels.length <= 3) return labels.join(', ');
        return `${labels.slice(0, 3).join(', ')} 외 ${labels.length - 3}개`;
    }

    public async removeItem(item) {
        let res = await this.service.alert.error("기업 정보를 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove", item);
        if (code !== 200) return alert("조합 삭제 실패!");
        await this.load(this.pagination.current);
    }

    public crawling: boolean = false;

    public async crawl() {
        let res = await this.service.alert.show({
            title: "뉴스 크롤링",
            message: "모든 투자기업의 최신 뉴스를 크롤링하시겠습니까?",
            cancel: "취소",
            actionBtn: "info",
            action: "크롤링",
            status: "info"
        });
        if (!res) return;
        this.crawling = true;
        await this.service.render();
        const { code, data } = await wiz.call("crawl");
        this.crawling = false;
        await this.service.render();
        if (code == 200) {
            let msg = `총 ${data.total_companies}개 기업 검색, ${data.company_count}개 기업에서 ${data.inserted}건의 새로운 뉴스가 등록되었습니다.`;
            if (data.errors && data.errors.length > 0) {
                msg += ` (${data.errors.length}건 오류)`;
            }
            await this.service.alert.show({
                title: "크롤링 완료",
                message: msg,
                actionBtn: "success",
                action: "확인",
                status: "success"
            });
        } else {
            await this.service.alert.show({
                title: "오류",
                message: data?.message || "크롤링에 실패했습니다.",
                actionBtn: "error",
                action: "확인",
                status: "error"
            });
        }
    }

    public statusMap(item) {
        if (item.investment_status == '운영') return 'operation';
        if (item.investment_status == '해산') return 'exit';
        return 'formed';
    }

    public baseLink(uri: string) {
        const path = this.categoryConfig[this.category]?.path || 'company';
        return '/admin/invest/' + path + uri;
    }
}

export default PortalLpsysadminCompanyListComponent;